import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SignupPopupButtonComponent } from '../components/signup-popup-button/signup-popup-button.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    NgbModule,
    RouterLink,
    RouterLinkActive,
    SignupPopupButtonComponent
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private modalService: NgbModal) { }

  showNav: boolean = false;

  toggleNav() {
    if(this.showNav == false) {
      this.showNav = true;
    } else {
      this.showNav = false;
    }
    console.log(this.showNav);
  }

  ngOnInit(): void {
  }

  openVerticallyCentered(content:any) {
    this.modalService.open(content, { centered: true , size: 'lg', scrollable:true});
  }
}
